/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarcombo_Eentwee4Inputs */

const nl_enums_leerjaarcombo_eentwee4 = /** @type {(inputs: Enums_Leerjaarcombo_Eentwee4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1/2`)
};

/**

* @param {Enums_Leerjaarcombo_Eentwee4Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarcombo_eentwee4 = /** @type {((inputs?: Enums_Leerjaarcombo_Eentwee4Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarcombo_Eentwee4Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarcombo_eentwee4(inputs)
});
export { enums_leerjaarcombo_eentwee4 as "enums.LeerjaarCombo.EenTwee" }